import './adapt'
import Vue from 'vue'
import './dependencies'
import './filter'
import './wxApi'

import QrcodeVue from 'qrcode.vue'
Vue.component('QrcodeVue', QrcodeVue)

import cache from './cached'
Vue.prototype.$cache = cache;

// import * as utils from './utils'
// Vue.prototype.$utils = utils;

// 全局请求方法
import api from '@/api'
Vue.prototype.$api = api;